import axios from "axios";
import TokenService from "./storage.service.js";
import Form from "../forms/Form.js";

export default class ApiService {
  constructor(baseURL) {
    this.interceptor401 = null;
    this.tokenService = new TokenService();
    this.axios = axios.create({
      baseURL: baseURL,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": true,
      },
    });
    window.axios = this.axios;
  }

  /**
   * Set User Authorization Header
   */
  setBearer() {
    this.axios.defaults.headers[
      "Authorization"
    ] = `Bearer ${this.tokenService.getToken()}`;
  }

  /**
   * Set User Authorization Header
   */
  removeBearer() {
    this.axios.defaults.headers["Authorization"] = null;
  }

/**
     * Handle the 401 error response
     */
    mountInterceptor401() {
        this.interceptor401 = this.axios.interceptors.response.use(
          (response) => {
            return response;
          },

          (error) => {
            // If server responded with 401 - Unauthorized
            if (error.request.status == 401) {
              // // Clear User from the Store
              // UserService.removeUser();
              // // Clear Access Token from Local Storage
              // UserService.removeToken();
              // router.push({ name: 'login' });
            }
            return Promise.reject(error);
          }
        );
    }

  /**
   * Remove the 401 interceptor
   */
  unmountInterceptor401() {
    this.axios.interceptors.response.eject(this.interceptor401);
  }

  /**
   * Get Method Wrapper
   */
  get(resource, options = null) {
    // console.log(axios.defaults);
    return this.axios.get(resource, options);
  }

  /**
   * Post Method Wrapper
   */
  post(resource, data, options = null) {
    if (data instanceof Form) {
      return data.send("post", resource, options);
    }

    // console.log(axios.defaults);
    return this.axios.post(resource, data, options);
  }

  /**
   * Put Method Wrapper
   */
  put(resource, data, options = null) {
    if (data instanceof Form) {
      return data.send("put", resource, options);
    }

    // console.log(axios.defaults);
    return this.axios.put(resource, data, options);
  }

  /**
   * Patch Method Wrapper
   */
  patch(resource, data, options = null) {
    if (data instanceof Form) {
      return data.send("patch", resource, options);
    }

    // console.log(axios.defaults);
    return this.axios.patch(resource, data, options);
  }

  /**
   * Delete Method Wrapper
   */
  delete(resource, data, options = null) {
    // console.log(axios.defaults);
    return this.axios.delete(resource, data, options);
  }

  /**
   * Perform a custom Axios request.
   *
   * data is an object containing the following properties:
   *  - method
   *  - url
   *  - data ... request payload
   *  - auth (optional)
   *    - username
   *    - password
   **/
  customRequest(data) {
    return this.axios(data);
  }
}
